/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {images} from '../../../../constants/image';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';

import {
  Modal,
  Button,
  Input,
  DateTimePicker,
  Select,
} from '../../../../components';

// style
import {
  Typography,
  StyledIconClose,
  StyledModalTitle,
  StyledModalActions,
  Divider,
} from './ModalFilter.style';

interface ModalFilterProps {
  visible: boolean;
  onClose?: () => void;
  handleFilter?: () => void;
  handleClean?: () => void;
  valueFilter?: any;
  setValueFilter?: Function;
  valueCreatedDateTimeRangePicker?: any;
  setValueCreatedDateTimeRangePicker?: Function;
  valueQrCodeExpiryDateTimeRangePicker?: any;
  setValueQrCodeExpiryDateTimeRangePicker?: Function;
  filterQrCodeExpiryStatusOptions?: any[];
  filterListedInAppParticipatingOutlets?: any[];
}

function ModalFilter({
  visible,
  onClose = () => {},
  handleFilter,
  handleClean = () => {},
  valueFilter,
  setValueFilter = () => {},
  valueCreatedDateTimeRangePicker,
  setValueCreatedDateTimeRangePicker = () => {},
  valueQrCodeExpiryDateTimeRangePicker,
  setValueQrCodeExpiryDateTimeRangePicker = () => {},
  filterQrCodeExpiryStatusOptions = [],
  filterListedInAppParticipatingOutlets = [],
}: ModalFilterProps) {
  const formatTime = 'DD/MM/YYYY HH:mm';

  const handleChange = (event: any) => {
    const {name, value} = event.target;
    const updatedValues: any = {
      [name]: value,
    };
    setValueFilter((prevState: any) => ({
      ...prevState,
      ...updatedValues,
    }));
  };

  const handleClose = () => {
    onClose();
    if (!visible) {
      handleClean();
    }
  };

  const shouldDisableCta = () => {
    const isAllFilterValuesEmpty = Object.values(valueFilter).every(
      (value: any) => ['', null, undefined].includes(value)
    );
    const isCreatedDateTimeRangeEmpty =
      !valueCreatedDateTimeRangePicker.startOfDateTime &&
      !valueCreatedDateTimeRangePicker.endOfDateTime;
    const isQrCodeExpiryDateTimeRangeEmpty =
      !valueQrCodeExpiryDateTimeRangePicker.startOfDateTime &&
      !valueQrCodeExpiryDateTimeRangePicker.endOfDateTime;
    return (
      isAllFilterValuesEmpty &&
      isCreatedDateTimeRangeEmpty &&
      isQrCodeExpiryDateTimeRangeEmpty
    );
  };

  return (
    <Modal visible={visible} onClose={handleClose}>
      <>
        <StyledModalTitle>Filter</StyledModalTitle>
        <StyledIconClose onClick={onClose}>
          <img src={images.icon_close} />
        </StyledIconClose>
        <Divider variant="middle" />
        <DialogContent>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              ID
            </Typography>
            <Input
              type="number"
              variant="outlined"
              placeholder="Enter ID"
              size="small"
              name="id_eq"
              value={valueFilter?.id_eq}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Island Partner name
            </Typography>
            <Input
              type="text"
              variant="outlined"
              placeholder="Enter Island Partner Name"
              size="small"
              name="name_contains"
              value={valueFilter?.name_contains}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl margin="dense" fullWidth>
            <Typography variant="subtitle2" mb={2}>
              Created start date time
            </Typography>
            <DateTimePicker
              required
              value={valueCreatedDateTimeRangePicker?.startOfDateTime}
              onChange={e => {
                if (
                  e !== null &&
                  e >= valueCreatedDateTimeRangePicker?.endOfDateTime
                ) {
                  setValueCreatedDateTimeRangePicker({
                    ...valueCreatedDateTimeRangePicker,
                    startOfDateTime: e,
                    endOfDateTime: null,
                  });
                } else {
                  setValueCreatedDateTimeRangePicker({
                    ...valueCreatedDateTimeRangePicker,
                    startOfDateTime: e,
                  });
                }
              }}
            />
          </FormControl>
          <FormControl margin="dense" fullWidth>
            <Typography variant="subtitle2" mb={2}>
              Created end date time
            </Typography>
            <DateTimePicker
              required
              value={valueCreatedDateTimeRangePicker?.endOfDateTime}
              minDate={
                valueCreatedDateTimeRangePicker?.startOfDateTime || new Date()
              }
              onChange={e => {
                setValueCreatedDateTimeRangePicker({
                  ...valueCreatedDateTimeRangePicker,
                  endOfDateTime: e,
                });
              }}
            />
          </FormControl>
          <FormControl margin="dense" fullWidth>
            <Typography variant="subtitle2" mb={2}>
              QR code expiry start date time
            </Typography>
            <DateTimePicker
              required
              value={valueQrCodeExpiryDateTimeRangePicker?.startOfDateTime}
              onChange={e => {
                if (
                  e !== null &&
                  e >= valueQrCodeExpiryDateTimeRangePicker?.endOfDateTime
                ) {
                  setValueQrCodeExpiryDateTimeRangePicker({
                    ...valueQrCodeExpiryDateTimeRangePicker,
                    startOfDateTime: e,
                    endOfDateTime: null,
                  });
                } else {
                  setValueQrCodeExpiryDateTimeRangePicker({
                    ...valueQrCodeExpiryDateTimeRangePicker,
                    startOfDateTime: e,
                  });
                }
              }}
            />
          </FormControl>
          <FormControl margin="dense" fullWidth>
            <Typography variant="subtitle2" mb={2}>
              QR code expiry end date time
            </Typography>
            <DateTimePicker
              required
              value={valueQrCodeExpiryDateTimeRangePicker?.endOfDateTime}
              minDate={
                valueQrCodeExpiryDateTimeRangePicker?.startOfDateTime ||
                new Date()
              }
              onChange={e => {
                setValueQrCodeExpiryDateTimeRangePicker({
                  ...valueQrCodeExpiryDateTimeRangePicker,
                  endOfDateTime: e,
                });
              }}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              QR code expiry status
            </Typography>
            <Select
              labelId="qrCodeExpiryStatus_eq"
              displayEmpty
              name="qrCodeExpiryStatus_eq"
              variant="outlined"
              onChangeSelect={handleChange}
              value={valueFilter.qrCodeExpiryStatus_eq}
              placeholder="Select QR code expiry status"
              size="small"
              selectOptions={filterQrCodeExpiryStatusOptions}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Listed in App's participating outlets (receipts accepted)?
            </Typography>
            <Select
              labelId="showOnMobileParticipatingList_eq"
              displayEmpty
              name="showOnMobileParticipatingList_eq"
              variant="outlined"
              onChangeSelect={handleChange}
              value={valueFilter.showOnMobileParticipatingList_eq}
              placeholder="Select participation status"
              size="small"
              selectOptions={filterListedInAppParticipatingOutlets}
            />
          </FormControl>
        </DialogContent>
        <Divider variant="middle" />
        <StyledModalActions>
          <div className="btn-action-1">
            <Button
              disabled={shouldDisableCta()}
              variant="text"
              onClick={handleClean}
            >
              Clear
            </Button>
          </div>
          <div className="btn-action-2">
            <Button disabled={shouldDisableCta()} onClick={handleFilter}>
              Apply Filter
            </Button>
          </div>
        </StyledModalActions>
      </>
    </Modal>
  );
}
export default ModalFilter;
